module.exports = "/10/2-mot-so-thao-tac-doc-du-lieu-tu-file-trong-c/index.html.9b18f400c922148fc3f9493ae1ee3652.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/35567.md
 ** module id = 587
 ** module chunks = 0
 **/